export async function doesUrlContainImage(url: string): Promise<boolean> {
	if (!URL.canParse(url)) {
		return false;
	}

	const downloadedImg = new Image();
	return new Promise((resolve) => {
		downloadedImg.addEventListener("load", () => {
			resolve(true);
		});
		downloadedImg.addEventListener("error", () => {
			resolve(false);
		});
		downloadedImg.src = url;
	});
}
